import i18n from "i18next";
import { ColumnsType } from "antd/lib/table/interface";
import { Member } from "@type/core/offices/offices.types";
import JseCertificateIcon from "@static/core/icons/icon-jse-certificate.svg?react";
import USInvalidCertificateIcon from "@static/core/icons/icon-us-invalid-certificate.svg?react";
import USProgressCertificateIcon from "@static/core/icons/icon-us-progress-certificate.svg?react";
import JseMemberIcon from "@static/core/icons/icon-jse-member.svg?react";

export const columns = (): ColumnsType<Member> => [
  {
    title: i18n.t("offices.users.headers.lastname"),
    dataIndex: "lastname",
    sorter: (a, b) => a.lastname?.localeCompare(b.lastname),
    showSorterTooltip: true,
    onCell: (record: Member) => ({
      colSpan: record.lastname && record.firstname ? 1 : 2,
    }),
    render: (lastname: string, record: Member) => {
      return lastname && record.firstname ? (
        lastname
      ) : (
        <span className="text-tertiary">
          {i18n.t("offices.users.waitingForConnexion")}
        </span>
      );
    },
  },
  {
    title: i18n.t("offices.users.headers.firstname"),
    dataIndex: "firstname",
    sorter: (a, b) => a.firstname?.localeCompare(b.firstname),
    showSorterTooltip: true,
    onCell: (record: Member) => ({
      colSpan: record.lastname && record.firstname ? 1 : 0,
    }),
  },
  {
    title: i18n.t("offices.users.headers.email"),
    dataIndex: "email",
  },
  {
    title: i18n.t("offices.users.headers.profile"),
    dataIndex: "profil",
  },
  {
    title: i18n.t("offices.users.headers.delegation"),
    dataIndex: "delegations",
  },
  {
    title: i18n.t("offices.users.guests.headers.csoStatus"),
    dataIndex: "csoStatus",
    width: 76,
    render: (csoStatus: string) => {
      return (
        <>
          {csoStatus && csoStatus === "VALID" && (
            <div className="d-flex justify-content-center">
              <JseCertificateIcon className="picto icon-30" />
            </div>
          )}
          {csoStatus && csoStatus === "INVALID" && (
            <div className="d-flex justify-content-center">
              <USInvalidCertificateIcon className="picto icon-30" />
            </div>
          )}
          {csoStatus &&
            (csoStatus === "PROGRESS" || csoStatus === "STARTED") && (
              <div className="d-flex justify-content-center">
                <USProgressCertificateIcon className="picto icon-30" />
              </div>
            )}
          {(!csoStatus || csoStatus === "" || csoStatus === "NOT_STARTED") && (
            <div className="d-flex justify-content-center">
              <JseMemberIcon className="picto icon-30" />
            </div>
          )}
        </>
      );
    },
  },
];
